var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelopeWhite48 = function SvgEnvelopeWhite48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M43.5 13.5v21A4.5 4.5 0 0 1 39 39H9a4.5 4.5 0 0 1-4.5-4.5v-21m39 0A4.5 4.5 0 0 0 39 9H9a4.5 4.5 0 0 0-4.5 4.5m39 0v.485a4.5 4.5 0 0 1-2.142 3.833l-15 9.23a4.5 4.5 0 0 1-4.716 0l-15-9.23A4.5 4.5 0 0 1 4.5 13.985V13.5"
  })));
};
export { SvgEnvelopeWhite48 as ReactComponent };
export default __webpack_public_path__ + "b3af1145ecfa43843f281280c24d836c.svg";